export default "__VITE_ASSET__BBeEibJ0__"